export class OperateurInformationsDomaine {
    libelle: string = undefined;
    code: string = undefined;
    valeur: string = undefined;
}
